import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useError } from "src/core/hooks/useError";
import { ToastContext } from "../../../../core/context/ToastContext";
import { useErrorHandler } from "../../../../core/error/useErrorHandler";
import { logService } from "../../../../core/services/logService";
import { useSettingsStore } from "../../../settings/services/useSettingsStore";
import { useAuthStore } from "../../services/useAuthStore";
import "./ActivatePage.css";

export function ActivatePage() {
  const toastRef = useContext(ToastContext);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getErrorMessage } = useError();

  const authStore = useAuthStore();
  const settingsStore = useSettingsStore();
  const errorHandler = useErrorHandler();

  useEffect(() => {
    if ((settingsStore?.errorList?.errorCodes?.length ?? 0) === 0) return;

    const queryParams = new URLSearchParams(location.search);

    logService.log("activate", queryParams);

    const key = queryParams.get("key");
    if (!key) {
      errorHandler.setError({
        title: t("Home.Activate.Title"),
        message: t("Home.Activate.Error"),
      });
    } else {
      authStore
        .activate(key)
        .then(() => {
          toastRef?.current?.show({
            severity: "success",
            summary: t("Home.Activate.Title"),
            detail: t("Home.Activate.Success"),
            closable: true,
            life: 15000,
          });

          navigate("/");
        })
        .catch((error) => {
          errorHandler.setError({
            title: t("Home.Activate.Title"),
            message: t("Home.Activate.Error") + " " + getErrorMessage(error),
          });

          navigate("/");
        });
    }
  }, [settingsStore.errorList]);

  return <div className="activatePage"></div>;
}
